// extracted by mini-css-extract-plugin
module.exports = {" _key":"sitepen-site/GDPRBanner","root":"GDPRBanner-m__root__f52bc32Ry1A","button":"GDPRBanner-m__button__f52bc31DJ11","hidden":"GDPRBanner-m__hidden__f52bc3qZpDD"};